<template>
	<div
		class="image-grid-card image-grid-card--click boundary-plus-thumbnail"
		role="button"
		tabindex="0"
		@click="$emit( 'open', item )"
		@keyup.enter="$emit( 'open', item )"
	>
		<div class="boundary-plus-thumbnail__media">
			<img
				v-if="thumbnail_url"
				:src="thumbnail_url"
				:alt="item.type === 'boundary_plus_image' ? 'Boundary+ image' : 'Boundary+ video thumbnail'"
				class="boundary-plus-thumbnail__image"
				loading="lazy"
				@load="$emit( 'image-loaded' )"
			>
			<div
				v-else
				class="boundary-plus-thumbnail__placeholder"
			/>

			<div
				v-if="item.type === 'boundary_plus_video'"
				class="boundary-plus-thumbnail__play-button"
				aria-hidden="true"
			>
				<span class="icon icon--play" />
			</div>

			<div
				v-if="item.type === 'boundary_plus_video' && formatted_duration"
				class="boundary-plus-thumbnail__duration"
			>
				{{ formatted_duration }}
			</div>
		</div>

		<button
			v-if="isStaff"
			class="image-grid-card__checkbox"
			:class="{ 'image-grid-card__checkbox--checked': checked }"
			:aria-label="checked ? 'Deselect item' : 'Select item for deletion'"
			@click.stop="$emit( 'check', item )"
		/>
	</div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';

const props = defineProps( {
	item: { required: true, type: Object },
	isStaff: { required: false, type: Boolean, default: false },
	checked: { required: false, type: Boolean, default: false }
} );

defineEmits( [ 'open', 'check', 'image-loaded' ] );

const thumbnail_url = computed( () => {
	if ( props.item.type === 'boundary_plus_image' ) {
		return props.item.image_small_url;
	}
	return props.item.thumbnail_url;
} );

const formatted_duration = computed( () => {
	if ( !props.item.duration ) {
		return null;
	}
	const seconds = props.item.duration;
	const minutes = Math.floor( seconds / 60 );
	const remaining_seconds = seconds % 60;
	return `${minutes}:${String( remaining_seconds ).padStart( 2, '0' )}`;
} );
</script>
